import React, { useState } from 'react'

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    overflow: 'auto',
  },
  container: {
    background: 'white',
    padding: '20px',
    width: '90%',
    maxWidth: '700px',
    margin: 'auto',
    borderRadius: '8px',
    outline: 'none',
    textAlign: 'center',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    textAlign: 'left',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 10,
  },
  content: {
    textAlign: 'left',
    margin: '15px 0',
    overflowY: 'auto',
    flexGrow: 1,
  },
  footer: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 10,
  },
  paragraph: {
    fontSize: '1em',
    margin: '10px 0',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '20px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1em',
    cursor: 'pointer',
    border: '1px solid #00ac9c',
    borderRadius: '5px',
    backgroundColor: '#00ac9c',
    color: 'white',
    transition: 'background-color 0.3s ease',
  },
  buttonOutlined: {
    backgroundColor: 'transparent',
    color: '#00ac9c',
  },
  buttonHover: {
    backgroundColor: '#00877a',
  },
  buttonsContainerLarge: {
    flexDirection: 'row',
    gap: '15px',
  },
  buttonLarge: {
    width: 'auto',
  },
}

const ReleasePopup = ({
  date,
  version,
  content,
  onClose,
  onTryIt,
  onShowWhatsNew,
}) => {
  const [hoveredButton, setHoveredButton] = useState(null)

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.container} onClick={(e) => e.stopPropagation()}>
        <style>
          {`
                    .release-popup h1 {
                        font-size: 1.5em;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .release-popup h2 {
                        font-size: 1.25em;
                        font-weight: bold;
                        margin-bottom: 8px;
                    }
                    .release-popup h3 {
                        font-size: 1.1em;
                        font-weight: bold;
                        margin-bottom: 6px;
                    }
                    .release-popup ul {
                        padding-left: 20px;
                        margin-bottom: 10px;
                    }
                    .release-popup li {
                        list-style-type: disc;
                        margin-left: 20px;
                    }
                `}
        </style>
        <div style={styles.header}>
          <h1
            style={{
              fontSize: '1.5em',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            Release Notes
          </h1>
          <h2
            style={{
              fontSize: '1.25em',
              fontWeight: 'bold',
              marginBottom: '8px',
            }}
          >
            Date : {date}
          </h2>
        </div>

        <div
          className="release-popup"
          style={styles.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />

        <div style={styles.footer}>
          <p style={styles.paragraph}>
            Have a question? Email us:
            <a
              style={{ color: '#00ac9c' }}
              href="mailto:support@hydrascore.com"
            >
              {' '}
              support@hydrascore.com
            </a>
          </p>
          <div
            style={{
              ...styles.buttonsContainer,
              ...(window.innerWidth >= 600 ? styles.buttonsContainerLarge : {}),
            }}
          >
            <button
              style={{
                ...styles.button,
                ...styles.buttonOutlined,
                ...(hoveredButton === 'try' ? styles.buttonHover : {}),
              }}
              onMouseEnter={() => setHoveredButton('try')}
              onMouseLeave={() => setHoveredButton(null)}
              onClick={onTryIt}
            >
              Try it on your own
            </button>
            <button
              style={{
                ...styles.button,
                ...(hoveredButton === 'show' ? styles.buttonHover : {}),
              }}
              onMouseEnter={() => setHoveredButton('show')}
              onMouseLeave={() => setHoveredButton(null)}
              onClick={onShowWhatsNew}
            >
              Show me what's new
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReleasePopup
